import {Component, Input, OnInit} from '@angular/core';
import {BaseFeeDetails, BaseFeeOption, FeeOptionService} from "../../../services/fee-option.service";
import {Constants} from "../../../utils/constants";
import {CoreDataService} from "../../../services/wrapper/core-data.service";
import {NotificationService} from "../../../services/common/notification.service";
import {Utilities} from "../../../utils/utilities";

@Component({
  selector: 'app-fee-option',
  templateUrl: './fee-option.component.html',
  styleUrls: ['./fee-option.component.scss']
})
export class FeeOptionComponent implements OnInit {

  @Input() feeOption:BaseFeeOption;
  @Input() restaurantHistoryId:number;

  public feePeriods = Constants.FEE_PERIOD_TYPE;
  public currencies:string[] = [];

  public isEdit = false;
  constructor(private coreDataService:CoreDataService,
              private feeOptionService:FeeOptionService,
              private notificationService:NotificationService
  ) { }

  ngOnInit() {
    this.coreDataService.getCurrencies().forEach(currency =>{
      this.currencies.push(currency.code);
    });

    if(this.feeOption.id == null){
      this.isEdit = true;
    }

    this.feeOption.feeDetailsList.forEach(feeDetail => {
      feeDetail.startDate = new Date(feeDetail.startDate);
      feeDetail.endDate = new Date(feeDetail.endDate);
    });
  }

  save() {
    try{
      this.feeOptionService.validate(this.feeOption);
      this.feeOptionService.saveOrUpdate(this.feeOption).subscribe(response =>{
        if(this.feeOption.id == null){
          this.feeOptionService.associateRestaurantHistory(this.restaurantHistoryId, response.id).subscribe(response =>{
            this.notificationService.showSuccess("general.success");
            this.isEdit = false;
          });
        }else{
          this.notificationService.showSuccess("general.success");
          this.isEdit = false;
        }
      })
    }catch (e) {
      console.log(e);
      this.notificationService.showError(e.message);
    }
  }

  addDetails() {
    this.feeOption.feeDetailsList.push(new BaseFeeDetails());
  }

  removeDetails(i: number) {
    this.feeOption.feeDetailsList.splice(i, 1);
  }
}
